export default {
    buttons: {
        login: 'Log In',
    },

    links: {
        forgot_password: 'Forgot password?',
    },

    fields: {
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
        password: {
            label: 'Password',
            placeholder: '6 characters minimum',
        },
    },
}
